import { getFirestore, collection, doc, getDoc, getDocs, updateDoc, deleteDoc, setDoc, arrayUnion, arrayRemove } from "firebase/firestore";
import { getStorage, ref, uploadString, getDownloadURL, deleteObject } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";

const db = getFirestore();

const storage = getStorage()
const storageImages = ref(storage, "preSetsImages/");

export default {
    state: {
        preSetsList: [],
        preSetStatusImage: 0,
        preSetsFilters: []
        // pwoCounterReproductor: {},
    },
    mutations: {
        SET_VALUE_LOADING_IMAGE_PRE_SET(state, value) {
            state.preSetStatusImage = value
        },
        SET_PRE_SET_LIST(state, preSetsList) {
            state.preSetsList = preSetsList;
        },
        SET_PRE_SET_FILTER_LIST(state, preSetsFilters) {
            state.preSetsFilters = preSetsFilters
        },
        ADD_ANY_VALUE_PRE_SET_FILTER_LIST(state, data) {
            let indexPrincipal = state.preSetsFilters.findIndex(filter => filter.type === data.doc)
            state.preSetsFilters[indexPrincipal].listFilters.push({ name: data.name, children: data.children })
        },
        DELETE_ANY_VALUE_PRE_SET_FILTER_LIST(state, data) {
            let indexPrincipal = state.preSetsFilters.findIndex(filter => filter.type === data.doc)
            let index = state.preSetsFilters[indexPrincipal].listFilters.indexOf(data.item.name)
            state.preSetsFilters[indexPrincipal].listFilters.splice(index, 1)
        },
        UPDATE_WITH_NEW_VALUES_PRE_SET_FILTER_LIST_CHILDREN(state, data) {
            let indexPrincipal = state.preSetsFilters.findIndex(filter => filter.type === data.doc)
            state.preSetsFilters[indexPrincipal].listFilters = data.updatedArray
        },
        UPDATE_FILTER_LIST_PRE_SET(state, data) {
            state.preSetsFilters.push({
                type: data.doc,
                listFilters: data.listFilters,
                name: data.name
            })
        },
        DELETE_VALUE_ROOT_FILTER_PRE_SET(state, data) {
            let indexPrincipal = state.preSetsFilters.findIndex(filter => filter.type === data.doc)
            state.preSetsFilters.splice(indexPrincipal, 1)
        }
    },
    actions: {
        GetPreSets({ commit }, notBindVuex) {
            return new Promise(async(resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "preSetsList"))
                    const preSetsList = []
                    querySnapshot.forEach((doc) =>  {
                        let preSet = doc.data()
                        preSet.typeWorkout = 'preSet';

                        preSet.completedTimes = preSet.completedTimes ? preSet.completedTimes : 0;

                        const calories = preSet.accumulatedCalories ? preSet.accumulatedCalories : 0;
                        const mxp = preSet.accumulatedMXP ? preSet.accumulatedMXP : 0;
                        const completedTimes = preSet.completedTimes ? preSet.completedTimes : 0;

                        const avgMXP = completedTimes > 0 ? mxp / completedTimes : 0;
                        const avgCalories = completedTimes > 0 ? calories / completedTimes : 0;

                        preSet.avgMXP = Number(avgMXP.toFixed(1));
                        preSet.avgCalories = Number(avgCalories.toFixed(1));

                        preSetsList.push(preSet)
                    })
                    if(!notBindVuex){
                     commit('SET_PRE_SET_LIST', preSetsList)
                    }
                    resolve(preSetsList)
                } catch(error) {
                    console.error(error);
                    reject(error)
                }
            });
        },
        BackupPreSets({ commit }){
            return new Promise(async(resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "preSetsList"))
                    const preSetsList = []
                    for (let i = 0; i < querySnapshot.docs.length; i++) {
                        let preSet = querySnapshot.docs[i].data();
                        preSetsList.push(preSet)
                        await setDoc(doc(db, "preSetsList-BACKUP-24-01-22", querySnapshot.docs[i].id), preSet)
                        console.log('updated documents: ', i+1)
                    }
                    console.log(preSetsList);
                } catch (error) {
                    console.error(error);
                    reject(error)
                }

            })

        },
        UpdateTwoHands({ commit }) {
            return new Promise(async(resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "preSetsList"))
                    const preSetsList = []
                    for (let i = 0; i < querySnapshot.docs.length; i++) {
                        let preSet = querySnapshot.docs[i].data();
                        if(preSet.typeBy === 'circuit' ){
                            for (let j = 0; j < preSet.circuits.length; j++) {
                                let circuit =  preSet.circuits[j]
                                for (let k = 0; k < circuit.exercises.length; k++) {
                                    let exercise = circuit.exercises[k]
                                    exercise.twoHands = true
                                    exercise.autoInit = false
                                }
                            }
                        }else if(preSet.typeBy === 'station'){
                            for (let x = 0; x < preSet.station.exercises.length; x++) {
                                let exercise = preSet.station.exercises[x]
                                exercise.twoHands = true
                                exercise.autoInit = false
                            }
                        }
                        await updateDoc(doc(db, "preSetsList", preSet.id), preSet)
                        console.log('documents updated:', i+1)
                        preSetsList.push(preSet);
                    }
                    

                    console.log(preSetsList)
                    resolve(preSetsList)
                } catch(error) {
                    reject(error)
                }
            });
        },
        GetPreSet({ }, preSet){
            return new Promise(async (resolve, reject) => {
                try {
                    let resPreSet = await getDoc(doc(db, "preSetsList", preSet.id))
                    let gettedPreSet = resPreSet.data();
                    if (!gettedPreSet) {
                        reject(new Error("Preset not found"));
                        return;
                    }
                    gettedPreSet.id = resPreSet.id;

                    // Modular SDK: DocumentReference has no .get(); use getDoc(ref).
                    // Some legacy presets may store a string id or plain object instead of a ref.
                    const sub = gettedPreSet.subscription;
                    if (sub && sub !== "") {
                        try {
                            let subSnap = null;
                            if (typeof sub.get === "function") {
                                subSnap = await sub.get();
                            } else if (typeof sub.path === "string" || typeof sub.id === "string") {
                                const subRef =
                                    typeof sub.path === "string"
                                        ? doc(db, sub.path)
                                        : doc(db, "subscriptionsList", sub.id);
                                subSnap = await getDoc(subRef);
                            } else if (typeof sub === "string") {
                                subSnap = await getDoc(doc(db, "subscriptionsList", sub));
                            }

                            if (subSnap && subSnap.exists()) {
                                gettedPreSet.subscription = { id: subSnap.id, ...subSnap.data() };
                            } else if (sub && typeof sub === "object" && sub.id) {
                                // Already a plain object from a previous hydrate; keep as-is.
                                gettedPreSet.subscription = sub;
                            } else {
                                gettedPreSet.subscription = "";
                            }
                        } catch (subErr) {
                            console.warn("GetPreSet: could not resolve subscription", subErr);
                            gettedPreSet.subscription = "";
                        }
                    }

                    if (gettedPreSet.endDay && typeof gettedPreSet.endDay.toDate === "function") {
                        gettedPreSet.endDay = gettedPreSet.endDay.toDate();
                    } else if (gettedPreSet.endDay && gettedPreSet.endDay._seconds != null) {
                        gettedPreSet.endDay = new Date(gettedPreSet.endDay._seconds * 1000);
                    } else if (!(gettedPreSet.endDay instanceof Date)) {
                        gettedPreSet.endDay = "";
                    }

                    resolve(gettedPreSet)
                } catch(error) {
                    console.error(error);
                    reject(error)
                }
            })
        },
        UploadImagePreSet({ commit }, preSet) {
            return new Promise(async (resolve, reject) => {
                try {
                    let random = uuidv4();
                    let storageRef = ref(storage, `preSetsImages/${random}`);
                    console.log('storageRef', storageRef.name);
                    
                    // Upload the string
                    await uploadString(storageRef, preSet.image.img, "data_url");
                    
                    // Get the download URL
                    const downloadURL = await getDownloadURL(storageRef);
                    resolve({ link: downloadURL, ref: random });
                } catch (error) {
                    console.log('error', error);
                    reject(error);
                }
            });
        },
        CreatePreSet({}, preSet) {
            return new Promise(async(resolve, reject) => {
                try {
                    delete preSet.image.img
                    if(preSet.subscription != ""){
                                           preSet.subscription = doc(db, "subscriptionsList", preSet.subscription.id)
                    }
                    const ref = doc(collection(db, "preSetsList"));
                    const newPreSet = await getDoc(ref);
                    preSet.id = newPreSet.id;
                    preSet.createdAt = new Date()
                    preSet.updatedAt = new Date()
                    await setDoc(ref, preSet)
                    resolve(newPreSet.id);
                } catch (error) {
                    reject(err);
                }
            })
        },
        CopyPreSet({}, id) {
            return new Promise(async(resolve, reject) => {
                try {
                    const preSet = await (await getDoc(doc(collection(db, "preSetsList"), id))).data()

                    const ref = doc(collection(db, "preSetsList"));
                    const newPreSet = await getDoc(ref);
                    preSet.id = newPreSet.id;
                    preSet.enable = false;
                    preSet.dynamicLink = '';
                    preSet.name['ENG'] = preSet.name['ENG'] + " Copy";
                    await setDoc(ref, preSet)
                    resolve(preSet);
                } catch (error) {
                    reject(err);
                }
            })
        },
        DeletePreSet({}, preSet) {
            return new Promise(async(resolve, reject) => {
                try {
                    // let storageRefImage = ref(storage, preSet.image.ref);
                    // await deleteObject(storageRefImage)
                    await deleteDoc(doc(db, "preSetsList", preSet.id))
                    resolve(preSet.id)
                } catch (error) {
                    reject(error);
                }
            });
        },
        UpdatePreSet({}, preSet) {
            return new Promise(async(resolve, reject) => {
                try {
                    if (preSet.image.img) {
                        delete preSet.image.img
                    }
                    if (preSet.counterReproductions.img) {
                        delete preSet.counterReproductions
                    }
                    if (preSet.createdAt) {
                        delete preSet.createdAt
                    }
                    preSet.updatedAt = new Date()
                    if(preSet.subscription && preSet.subscription != ""){
                        preSet.subscription = doc(db, "subscriptionsList", preSet.subscription.id)
                    }
                    await updateDoc(doc(db, "preSetsList", preSet.id), preSet)
                    resolve(preSet.id);
                } catch (error) {
                    reject(err);
                }
            });
        },
        UpdatePresetValue({}, obj){
            return new Promise(async(resolve, reject) => {
                try {
                    await updateDoc(doc(db, "preSetsList", obj.id), obj.data);
                    resolve(obj.id);
                } catch (error) {
                    console.log(error);
                    
                    reject(error);
                }
            });
        },
        //Filters
        GetFiltersListPreSets({ commit }) {
            return new Promise(async(resolve, reject) => {
                try {
                    const querySnapshot = await getDocs(collection(db, "preSetsFilters"))
                    const preSetsFilters = [];
                    querySnapshot.forEach((doc) => {
                        let filterPreSets = doc.data();
                        filterPreSets.type = doc.id
                        preSetsFilters.push(filterPreSets);
                    });
                    commit("SET_PRE_SET_FILTER_LIST", preSetsFilters);
                    resolve(preSetsFilters); 
                } catch (error) {
                    reject(error)
                }
            });
        },
        AddNewTypeToListOfFiltersPreSets({ commit }, data) {
            return new Promise(async(resolve, reject) => {
                try {
                                         const res = await updateDoc(doc(db, "preSetsFilters", data.doc), {
                         listFilters: arrayUnion({ name: data.name, children: data.children })
                      })
                    commit("ADD_ANY_VALUE_PRE_SET_FILTER_LIST", data);
                    resolve(res);
                } catch (error) {
                    reject(error)
                }
            })
        },
        DeleteTypeToListOfFiltersPreSets({ commit }, data) {
            return new Promise(async(resolve, reject) => {
                try {
                                       const res = await updateDoc(doc(db, "preSetsFilters", data.doc), {
                         listFilters: arrayRemove(data.item)
                     })
                        commit('DELETE_ANY_VALUE_PRE_SET_FILTER_LIST', data)
                        resolve(res);
                } catch (error) {
                        reject(error);
                }
            })
        },
        AddOrDeleteChildrenToListOfFiltersPreSets({ commit }, data) {
            return new Promise(async(resolve, reject) => {
                try {
                                         const res = await updateDoc(doc(db, "preSetsFilters", data.doc), {
                         listFilters: data.updatedArray
                      })
                    commit("UPDATE_WITH_NEW_VALUES_PRE_SET_FILTER_LIST_CHILDREN", data);
                    resolve(res);
                } catch (error) {
                    reject(err);
                }
            })
        },
        CreateNewFilterPreSets({ commit }, data) {
            return new Promise(async(resolve, reject) => {
                try {
                    const res = await setDoc(doc(db, "preSetsFilters", data.doc), {
                        name: data.name,
                        listFilters: data.listFilters,
                    })
                    commit("UPDATE_FILTER_LIST_PRE_SET", data);
                    resolve(res);
                } catch (error) {
                    reject(err);
                }
            })
        },
        DeleteFilterPreSets({ commit }, data) {
            return new Promise(async(resolve, reject) => {
                try {
                                         const res = await deleteDoc(doc(db, "preSetsFilters", data.doc))
                    commit("DELETE_VALUE_ROOT_FILTER_PRE_SET", data);
                    resolve(res);
                } catch (error) {
                    reject(err);
                }
            })
        },

    },
    getters: {
        getPreSets(state) {
            return state.preSetsList;
        },
        getLoadingImagePreSet(state) {
            return state.pwoStatusImage;
        },
        getPreSetsFilters(state) {
            return state.preSetsFilters
        },
    }
}